export default {
  namespaced: true,
  state: {
    shown: false,
    text: '',
    color: '',
    x: 0,
    y: 0
  },
  mutations: {
    setPositionFromEvent (state, event) {
      state.x = event.clientX
      state.y = event.clientY
    },
    setPosition (state, { x, y }) {
      state.x = x
      state.y = y
    },
    setText (state, text) {
      state.text = text
    },
    setColor (state, color) {
      state.color = color
    },
    show (state, { x, y, text, color }) {
      state.x = x
      state.y = y
      state.text = text
      state.color = color
      state.shown = true
    },
    hide (state) {
      state.shown = false
    }
  },
  actions: {

  }
}
